export default {
  noSpace (value) {
    return !/[ \t]/.test(value)
  }
}
